import { createReducer } from '@src/redux/helpers/createReducer';
import { config } from '@uhg-abyss/web/tools/config';
import { GET_USER_INFO, VALIDATE_USER } from './constants';

const initialState = {
  uuid: '',
  optumId: '',
  firstName: '',
  lastName: '',
  email: '',
  username: '',
  isSuperUser: false,
  isCheckoutUser: false,
  validateUserSaga: { isError: false, isLoading: false, isSuccess: false },
};

export const userInfoReducer = createReducer(initialState, {
  [`${GET_USER_INFO}_SUCCESS`]: (state, action) => {
    return {
      ...action.payload,
      isCheckoutUser:
        config('ENABLE_PROD_CHECKOUT') &&
        config('PROD_CHECKOUT_USERS').includes(action.payload.username),
    };
  },
  [`${VALIDATE_USER}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      isSuperUser: action.payload.active,
      validateUserSaga: { isError: false, isLoading: false, isSuccess: true },
    };
  },
  [`${VALIDATE_USER}_ERROR`]: (state, action) => {
    return {
      ...state,
      isSuperUser: false,
      validateUserSaga: { isError: true, isLoading: false, isSuccess: false },
    };
  },
  [`${VALIDATE_USER}_STARTED`]: (state, action) => {
    return {
      ...state,
      validateUserSaga: { isError: false, isLoading: true, isSuccess: false },
    };
  },
});
